import { Fragment } from 'react';
import { Typography, Grid, Box, Stack } from '@mui/material';
import Form from 'components/Form';

import RowContainer from '../../components/RowContainer';
import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const checks = [
  {
    label: 'Ống thông tĩnh mạch dưới đòn',
    key: 'no1.checked1',
  },
  {
    label: 'Ống thông Hickman',
    key: 'no1.checked2',
  },
  {
    label: 'Ống thông trung tâm đặt vào từ ngoại vi',
    key: 'no1.checked3',
  },
  {
    label: 'Cổng hóa trị',
    key: 'no1.checked4',
  },
];

const CVCone = (props: Props) => {
  const { disabled, register, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="1. Định nghĩa và các loại ống dẫn tĩnh mạch trung tâm" />

      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            Khác với các tĩnh mạch ngoại vi nhỏ nằm ở các khu vực như tay hoặc
            chân, các tĩnh mạch trung ương tham chiếu đến các tĩnh mạch lớn như
            tĩnh mạch dưới cánh tay, tĩnh mạch cổ, và
            <br />
            tĩnh mạch đùi mà kết nối với thân thể và dẫn đến trái tim. Một ống
            dẫn tĩnh mạch trung ương là một loại ống dẫn được chèn vào những
            tĩnh mạch trung ương lớn này. Một khi được chèn
            <br />
            vào và hoạt động tốt, nó có thể được sử dụng liên tục mà không cần
            phải tiến hành truy cập mạch máu riêng biệt mỗi lần cần phải tiêm
            chích thông qua tĩnh mạch.
          </Typography>
          {checks.map((v, i) => {
            return (
              <Grid item xs={11.5} sx={{ margin: '0px 0 0 15px' }}>
                <Form.MuiCheckbox
                  label={v.label}
                  disabled={disabled}
                  defaultValue={Boolean(getValues(v.key)) ? [v.label] : []}
                  onChange={(_, checked) => {
                    setValue(v.key, checked);
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCone;
